export default __webpack_public_path__ + "9e44e2419f5b45200543a58daa266bb3.png";